export const module = {
  info: {
    name: 'voip-rtp-finder',
    caption: 'rtp',
    viewGroup: 'general-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'RTP Finder',
    icon: 'el-icon-zoom-in',
    routeName: 'module->voip-rtp-finder->panel',
    children: [
      {
        caption: 'RTP List',
        icon: 'el-icon-view',
        routeName: 'module->voip-rtp-finder->panel'
      },
      {
        caption: 'Similar View',
        icon: 'el-icon-document-copy',
        routeName: 'module->voip-rtp-finder->similar-view'
      }
    ]
  }
}

export default module
